module.exports = __webpack_public_path__ + "static/media/ebis-app-logo@2x.01053c95.png";